<template>
  <div>
    <sl-dropdown
      placement="bottom-end"
      distance="10"
      skidding="-10"
      :disabled="!user"
      hoist
    >
      <Trigger slot="trigger">
        <ItsAvatarPill
          size="s"
          :imgPath="avatar"
          :initialsContent="initials"
          :pillColor="userState"
          role="presentation"
        />
      </Trigger>
      <div class="py-2 rounded-[--sl-border-radius-medium] bg-white">
        <div class="py-2 px-4 hover:bg-[#F65030] hover:text-white">
          <a :href="`${baseUrl}/utilisateur/deconnect`">Me déconnecter</a>
        </div>
      </div>
    </sl-dropdown>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ItsAvatarPill } from "@developpeur/core-lib-front";
import Trigger from "@/shared/ui/Trigger.vue";
import { UserConnecte } from "@/entities/user/model/User";

const { baseUrl = "", user = undefined } = defineProps<{
  baseUrl: string;
  user?: UserConnecte;
}>();

const userState = computed(() => (user ? "success" : "error"));

const initials = computed(() =>
  user ? `${user.prenom.charAt(0)}${user.nom.charAt(0)}` : "",
);

const avatar = computed(() =>
  user && baseUrl ? `${baseUrl}/${user.avatar}` : "",
);
</script>
